import { render, staticRenderFns } from "./faturamentoAtrasadoSideBar.vue?vue&type=template&id=2018b37e"
import script from "./faturamentoAtrasadoSideBar.vue?vue&type=script&lang=js"
export * from "./faturamentoAtrasadoSideBar.vue?vue&type=script&lang=js"
import style0 from "./faturamentoAtrasadoSideBar.vue?vue&type=style&index=0&id=2018b37e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports